// extracted by mini-css-extract-plugin
export default {"title":"NewsList-module--title--g+K5y","list":"NewsList-module--list--93CMG","itemWrapper":"NewsList-module--itemWrapper--ZXj4T"};